import { createApi } from '@reduxjs/toolkit/query/react'
import { MANAGE_RECEIPTS_CREATE, MANAGE_RECEIPTS_DELETE, MANAGE_RECEIPTS_LIST } from 'config/apiPaths';
import axiosBaseQuery from "utils/axios/axiosBaseQuery"

export const receiptApi = createApi({
    reducerPath: 'receiptApi',
    baseQuery: axiosBaseQuery({
        baseUrl: "/reciept",
    }),
    endpoints: (builder) => ({

        // List
        getReceiptsList: builder.query({
            query: ({ search = "", clientId, page = 1, limit = 10, consent_for = "", sort = { column: "id", direction: "DESC" } }) => ({
                method: "PATCH",
                url: `${MANAGE_RECEIPTS_LIST}/${clientId}`,
                data: { search, page, limit, sort },
            }),
            transformResponse: (response) => {
                return response.data;
            },
            providesTags: ["receiptsList"]
        }),

        // create 
        createReceipts: builder.mutation({
            query: (data) => ({
                method: "POST",
                url: MANAGE_RECEIPTS_CREATE,
                data
            }),
            invalidatesTags: ["receiptsList"]
        }),

        // // consent form details
        // getConsentFormDetails: builder.query({
        //     query: (id) => ({
        //         method: "GET",
        //         url: `${MANAGE_CONSENT_VIEW}/${id}`
        //     }),
        //     transformResponse: (response) => {
        //         return response.data;
        //     },
        //     providesTags: ["FormDetails"]
        // }),

        // // update consent form
        // updateConsentForm: builder.mutation({
        //     query: ({ id, data }) => ({
        //         method: "PUT",
        //         url: `${MANAGE_CONSENT_UPDATE}/${id}`,
        //         data
        //     }),
        //     invalidatesTags: ["FormList", "FormDetails"]
        // }),

        // delete consent form
        deleteReceiptForm: builder.mutation({
            query: ({id}) => ({
                method: "DELETE",
                url: `${MANAGE_RECEIPTS_DELETE}/${id}`
            }),
            invalidatesTags: ["receiptsList"]
        }),
    }),
})

export const {
    useCreateReceiptsMutation,
    useGetReceiptsListQuery,
    useDeleteReceiptFormMutation
} = receiptApi;